const f="#ffffff",o=352;export{o as DEFAULT_COLOURS_SELECT_CALLOUT_WIDTH,f as DEFAULT_COLOURS_SELECT_VALUE};
//# sourceMappingURL=ColourSelect.types.js.map
